<template>
  <b-modal
    :visible="visible"
    no-close-on-backdrop
    :title="$t('policy_exception.workflow.reassign_title')"
    :ok-title="$t('policy_exception.workflow.reassign')"
    :cancel-title="$t('actions.cancel')"
    @hidden="$emit('close')"
    @ok.prevent="handleSubmit"
  >
    <b-form-group :label="$t('policy_exception.assigned_to')" label-for="reassign-user">
      <v-select
        id="reassign-user"
        v-model="selectedUserId"
        :options="userOptions"
        :reduce="(val) => val.value"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        :placeholder="$t('policy_exception.select_user')"
        class="w-100"
      />
    </b-form-group>
  </b-modal>
</template>

<script>
import { ref, watch } from '@vue/composition-api'
import vSelect from 'vue-select'
import store from '@/store'

export default {
  name: 'ReassignModal',
  components: {
    vSelect,
  },
  props: {
    visible: { type: Boolean, default: false },
    userOptions: { type: Array, default: () => [] },
  },
  setup(props, { emit }) {
    const selectedUserId = ref(null)

    watch(
      () => props.visible,
      (visible) => {
        if (!visible) selectedUserId.value = null
      }
    )

    const handleSubmit = () => {
      if (!selectedUserId.value) return
      emit('confirm', { id_user: selectedUserId.value })
    }

    return {
      selectedUserId,
      handleSubmit,
    }
  },
}
</script>
